import React from 'react';
import styled from '@emotion/styled';

type Props = {
  className?: string,
  hasCounterAsButton?: Boolean,
  decreaseButton: React.Node,
  counter?: React.Node,
  counterAsButton?: React.Node,
  isCentered?: Boolean,
};

export const QuantityContainer = ({
  className,
  hasCounterAsButton,
  decreaseButton,
  counter,
  counterAsButton,
  isCentered,
}: Props) => (
  <Container
    className={className}
    data-test="quantity-counter"
    hasCounterAsButton={hasCounterAsButton}
    isCentered={isCentered}
  >
    {decreaseButton}
    {hasCounterAsButton ? counterAsButton : counter}
  </Container>
);

const Container = styled('div')`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 8px;

  ${({ isCentered }) => isCentered && `justify-content: center`};
`;
